import { REDUX_ACTIONS, GAME_ID } from 'a/wordSlide/data/constants';

const initState = {
  isDraggable: true,
  position: 0, // 0 - 'off', 1 - 'on'
};

const confirmationButtonReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.ENABLE_CONFIRMATION_BUTTON:
      return {
        ...state,
        isDraggable: true,
      };

    case REDUX_ACTIONS.DISABLE_CONFIRMATION_BUTTON:
      return {
        ...state,
        isDraggable: false,
      };

    case REDUX_ACTIONS.SET_CONFIRMATION_BUTTON_POSITION: {
      const { position } = payload;
      return {
        ...state,
        position,
      };
    }

    default:
      return state;
  }
};

export default confirmationButtonReducer;
